import React from 'react';
import './conclusao.scss';

class Conclusao extends React.Component {
  componentWillUnmount() {
    const { tipoSocio, idSocio } = this.props;
    this.props.toggleDoneAssociadoAction(tipoSocio, idSocio, false);
  }

  render() {
    return (
      <div className="conclusao-associado">
        <div className="col">
          <i className={ `icon fa fa-check-circle-o`}></i>
          <h1 className="title">Cliente salvo!</h1>
          <span className="message">O cadastro deste cliente será efetivado ao concluir o cadastro da empresa.</span>
        </div>
      </div>);
  }
}

export default Conclusao;